import React from 'react';

const Loading: React.FC = (): JSX.Element => {
  return (
    <div className="absolute left-0 top-0 z-50 flex size-full items-center justify-center">
      <div className="fixed left-0 top-0 size-full bg-gray-500 opacity-75"></div>
      <div className="flex-col items-center justify-center">
        <div
          className="ml-auto inline-block size-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-700 motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        ></div>
      </div>
    </div>
  );
};

export default Loading;
